import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { restoreSession } from "Projects/CC_cubi_clan_project/Utils/SessionManager";
import { rememberReturnPath } from "Projects/CC_cubi_clan_project/Utils/AuthNavigation";

export function AuthGate({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let active = true;
    restoreSession(undefined, { force: true })
      .then((profile) => {
        if (active) setStatus(profile ? "authenticated" : "anonymous");
      })
      .catch(() => {
        // Connectivity is not evidence that a valid session has expired. The
        // backend still enforces authorization on every protected request.
        if (active) setStatus("network-error");
      });
    return () => {
      active = false;
    };
  }, []);

  if (status === "checking") return null;
  if (status === "network-error") {
    return <div role="status">No se pudo verificar la sesión. Revisa la conexión e inténtalo de nuevo.</div>;
  }
  if (status === "anonymous") {
    rememberReturnPath(location.pathname + location.search + location.hash);
    return <Navigate to="/" replace />;
  }
  return children;
}
